import { useAlgoliaQueryHook } from "@utils/hooks/algolia/useAlgoliaQuery.hook";
import { useSharedWishListId } from "@utils/hooks/useSharedWishlistId.hook";
import { useTrackingID } from "@utils/hooks/useTrackingId.hook";

export const useLanguageSelectorPath = (path: string) => {
    const algoliaQuery = useAlgoliaQueryHook();
    const sharedWishListId = useSharedWishListId();
    const trackingId = useTrackingID();

    return `${path}${algoliaQuery}${sharedWishListId}${trackingId}`;
};
